import update from "immutability-helper";
import React, {useCallback, useRef, useState } from "react";
//import { useReactToPrint } from "react-to-print";
import { ItemTypes } from "./dnd/ItemTypes.js";
import { WordHome } from "./dnd/WordHome.js";
import { WordLabel } from "./dnd/WordLabel.js";
import "./dnd/dnd.css";

//import PrintIcon from "@mui/icons-material/Print";
import AcrossFlags from "./boardElements/AcrossFlags";
import DownFlags from "./boardElements/DownFlags";
import "./css/crossword_style.css";

const BuildCrosswordJson = (props) => {
  const [solutionBoard, setSolutionBoard] = useState("none");
  const [solutionButtonTxt, setSolutionButtonTxt] = useState("Solution");
  const [solutionButtonColor, setSolutionButtonColor] = useState("yellow");

  const componentRef = useRef();
  
  /*
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Document Title",
  });
  */

  const wordHomesArray = [];
  //boardSize of the board is rows_num * cols
  // IMPORTANT: The board size has to be updated here manually with the size of the crossword board,otherwise
  // the dnd does not work.
  const boardSize = 36;

  for (var j = 0; j < boardSize; j++) {
    wordHomesArray.push({
      text: "",
      accepts: [
        ItemTypes.A,
        ItemTypes.B,
        ItemTypes.C,
        ItemTypes.D,
        ItemTypes.E,
        ItemTypes.F,
        ItemTypes.G,
        ItemTypes.H,
        ItemTypes.I,
        ItemTypes.J,
        ItemTypes.K,
        ItemTypes.L,
        ItemTypes.M,
        ItemTypes.N,
        ItemTypes.O,
        ItemTypes.P,
        ItemTypes.Q,
        ItemTypes.R,
        ItemTypes.S,
        ItemTypes.T,
        ItemTypes.U,
        ItemTypes.V,
        ItemTypes.W,
        ItemTypes.X,
        ItemTypes.Y,
        ItemTypes.Z,
        ItemTypes.ERASER,
      ],
      lastDroppedItem: null,
    });
  }

  const [wordHomes, setWordHomes] = useState(wordHomesArray);

  const [wordLabels] = useState([
    { name: "A", type: ItemTypes.A },
    { name: "B", type: ItemTypes.B },
    { name: "C", type: ItemTypes.C },
    { name: "D", type: ItemTypes.D },
    { name: "E", type: ItemTypes.E },
    { name: "F", type: ItemTypes.F },
    { name: "G", type: ItemTypes.G },
    { name: "H", type: ItemTypes.H },
    { name: "I", type: ItemTypes.I },
    { name: "J", type: ItemTypes.J },
    { name: "K", type: ItemTypes.K },
    { name: "L", type: ItemTypes.L },
    { name: "M", type: ItemTypes.M },
    { name: "N", type: ItemTypes.N },
    { name: "O", type: ItemTypes.O },
    { name: "P", type: ItemTypes.P },
    { name: "Q", type: ItemTypes.Q },
    { name: "R", type: ItemTypes.R },
    { name: "S", type: ItemTypes.S },
    { name: "T", type: ItemTypes.T },
    { name: "U", type: ItemTypes.U },
    { name: "V", type: ItemTypes.V },
    { name: "W", type: ItemTypes.W },
    { name: "X", type: ItemTypes.X },
    { name: "Y", type: ItemTypes.Y },
    { name: "Z", type: ItemTypes.Z },
    { name: " ", type: ItemTypes.ERASER},
  ]);

  // const [droppedWordLabelNames, setDroppedWordLabelNames] = useState([]);

  // Track the letters drops event in the board
  const gameStartedTracked = useRef(false);

  const handleDrop = useCallback(
    (index, item) => {
      const { name } = item;

      // Track the first letter placed on the board.
      if (name !== " " && !gameStartedTracked.current) {
        gameStartedTracked.current = true;

        window.gtag?.("event", "game_started", {
          game_name: "todays_mini_crossword",
        });
      }

      /*setDroppedWordLabelNames(name);*/
      setWordHomes(
        update(wordHomes, {
          [index]: {
            lastDroppedItem: {
              $set: name,
            },
          },
        })
      );
    },
    [/*droppedWordLabelNames,*/ wordHomes]
  );

  // EXTREMELY IMPORTANT NOTE: The rows and cols from the props comes as strings not as numbers.
  // We need to have type numbers in rows and cols otherwise the for loops needed in the application
  // which use the rows and cols do not work as expected producing 'silent' errors (strange behaviour)
  // which are very difficult to see in JS as programs do not crush they carry on ...
  const rows = Number(props.chosenCrossword.rows_num);
  const cols = Number(props.chosenCrossword.cols);
  const crosswordString = props.chosenCrossword.final_board.toUpperCase();
  const across = props.chosenCrossword.across_defs.replaceAll("^", '"');
  const down = props.chosenCrossword.down_defs.replaceAll("^", '"');

  // cellWidth should be equal to width in dnd.css .wordHome class
  const cellWidth = 50;
  const cellHeight = cellWidth;
  const blackCellSize = cellWidth - 4;
  const BLACK = "*";
  const WHITE = " ";
  const addWidth = 2 * cols;
  const boardWidth = cellWidth * cols + addWidth;
  const boardHeight = cellHeight * rows + addWidth;
  const gridWidth = boardWidth + 40;

  const acrossFlags = AcrossFlags(rows, cols, BLACK, crosswordString);
  const downFlags = DownFlags(rows, cols, BLACK, crosswordString);


  let crosswordArray = [];
  let crosswordBoardArray = [];
  let startingCrosswordBoard = [];
  var indexH = 1;
  var indexV = 1;

  for (var i = 0; i < crosswordString.length; i++) {
    // Crossword Solution array
    if (crosswordString[i] === BLACK) {
      crosswordArray.push([BLACK, "#000"]);
    } else {
      crosswordArray.push([crosswordString[i], "transparent"]);
    }

    // Crossword Board array
    if (crosswordString[i] === BLACK) {
      crosswordBoardArray.push([BLACK, "#000"]);
    } else {
      crosswordBoardArray.push([WHITE, "transparent"]);
    }

    // Starting Crossword Board
    if (crosswordString[i] === BLACK) {
      startingCrosswordBoard.push([BLACK, "#000", " ", " "]);
    } else {
      if (acrossFlags.includes(i) && downFlags.includes(i)) {
        startingCrosswordBoard.push([
          crosswordString[i],
          "#fff",
          //indexH + "→",
          //indexV + "↓",
          indexH + " ",
          indexV + " ",
        ]);
        indexH++;
        indexV++;
      } else if (acrossFlags.includes(i)) {
        startingCrosswordBoard.push([
          crosswordString[i],
          "#fff",
          //indexH + "→",
          indexH + " ",
          " ",
        ]);
        indexH++;
      } else if (downFlags.includes(i)) {
        startingCrosswordBoard.push([
          crosswordString[i],
          "#fff",
          " ",
          //indexV + "↓",
          indexV + " ",
        ]);
        indexV++;
      } else {
        startingCrosswordBoard.push([crosswordString[i], "#fff", " ", " "]);
      }
    }
  }

  function handleCrosswordSolutionOnClick(e) {
    e.preventDefault();
    if (solutionBoard === "none") {
      setSolutionBoard("block");
      setSolutionButtonTxt("Close Solution");
      setSolutionButtonColor("deepSkyBlue");
      
      // GA4 event
      window.gtag?.("event", "show_solution");
      
    } else {
      setSolutionBoard("none");
      setSolutionButtonTxt("Solution");
      setSolutionButtonColor("yellow");
    }
  }

  return (
    <div
      className="crosswordElementsGrid"
      style={{
        width: `${gridWidth}px`,
        padding:'16px 0',
        height:'1100px',
      }}
    >
      <div
        className="buildCrosswordContainer"
        style={{
          width: `${boardWidth}px`,
          margin: "0 auto",
        }}
      >
        <div
          className="buildCrossword"
          style={{
            width: `${boardWidth}px`,
            margin: "0 auto",
          }}
        >
          {startingCrosswordBoard.map((boardItem, index) => (
            <div
              key={index}
              className="crosswordCells"
              style={{
                width: `${cellWidth}px`,
                height: `${cellHeight}px`,
                backgroundColor:'#fff',
              }}
            >
              <div style={{margin:'2px',width:`${blackCellSize}px`,height:`${blackCellSize}px`,backgroundColor: boardItem[1]}}></div>
              <div className="acrossFlags">{boardItem[2]}</div>
              <div className="downFlags">{boardItem[3]}</div>
            </div>
          ))}
        </div>
        <div className="copyright">TodaysMiniCrossword©</div>

        <div
          className="wordHomeWrapper"
          style={{
            zIndex: "5000",
            width: `${boardWidth}px`,
            height: `${boardHeight}px`,
            margin: "0 auto",
          }}
        >
          {wordHomes.map(({ accepts, lastDroppedItem, text }, index) => (
            <WordHome
              accept={accepts}
              lastDroppedItem={lastDroppedItem}
              text={text}
              onDrop={(item) => handleDrop(index, item)}
              key={index}
            />
          ))}
        </div>
        <div className="wordLabelWrapper">
          {wordLabels.map(({ name, type }, index) => (
            <WordLabel name={name} type={type} key={index} />
          ))}
        </div>
        <div style={{marginTop:'1rem',textAlign:'center', fontSize:'1.5rem'}}>🔠 Drag & Drop Letters</div>
        <div className="wordDefinitions">
          <b>Across :</b>
          <p>{across}</p>
        </div>
        <div className="wordDefinitions">
          <b>Down :</b>
          <p>{down}</p>
        </div>
        <div className="crosswordSolution">
          <button
            onClick={handleCrosswordSolutionOnClick}
            style={{
              backgroundColor: `${solutionButtonColor}`,
            }}
          >
            <b>{solutionButtonTxt}</b>
          </button>
          <div style={{ display: `${solutionBoard}` }}>
            <div
              className="buildCrossword"
              style={{
                width: `${boardWidth}px`,
                margin: "0 auto",
                marginTop: "1em",
              }}
            >
              {startingCrosswordBoard.map((boardItem, index) => (
                <div
                  key={index}
                  className="crosswordCells"
                  style={{
                    width: `${cellWidth}px`,
                    height: `${cellHeight}px`,
                    backgroundColor: '#fff',
                    textAlign: "center",
                    lineHeight: `${cellHeight}px`,
                    verticalAlign: "middle",
                    color: "#000",
                  }}
                >
                  <div style={{margin:'2px',width:`${blackCellSize}px`,height:`${blackCellSize}px`,backgroundColor: boardItem[1]}}>
                  <b>{boardItem[0]}</b>
                  </div>
                  <div className="acrossFlags" style={{fontSize:"1rem", lineHeight:"1.6em"}}>{boardItem[2]}</div>
                  <div className="downFlags" style={{fontSize:"1rem", lineHeight:"1.6em"}}>{boardItem[3]}</div>
                  
                </div>
              ))}
            </div>
            <div className="copyright">TodaysMiniCrossword ©</div>
          </div>
        </div>
      </div>
      {/*
      <button style={{ margin: "0 auto" }} onClick={handlePrint}>
        <PrintIcon />
      </button>
      */}
      <div style={{ display: "none" }}>
        <div
          className="buildCrosswordContainer"
          ref={componentRef}
          style={{
            width: `${boardWidth}px`,
            margin: "50px auto",
            height: "90vh",
            position: "relative",
          }}
        >
          <h1
            style={{
              textAlign: "center",
              margin: "20px auto",
              width: "100%",
            }}
          >
            Crossword
          </h1>
          <div
            className="buildCrossword"
            style={{
              width: `${boardWidth}px`,
              height: `${boardHeight}px`,
              margin: "0 auto",
            }}
          >
            {startingCrosswordBoard.map((boardItem, index) => (
              <div
                key={index}
                className="crosswordCells"
                style={{
                  width: `${cellWidth}px`,
                  height: `${cellHeight}px`,
                  backgroundColor: boardItem[1],
                }}
              >
                <div className="acrossFlags">{boardItem[2]}</div>
                <div className="downFlags">{boardItem[3]}</div>
              </div>
            ))}
          </div>
          <div className="copyright" style={{ color: "#000" }}>
          TodaysMiniCrossword ©
          </div>

          <div className="wordDefinitions" style={{ color: "#000" }}>
            <b>Across :</b>
            <p>{across}</p>
          </div>
          <div className="wordDefinitions" style={{ color: "#000" }}>
            <b>Down :</b>
            <p>{down}</p>
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "0",
              left: "40px",
              color: "#000",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span
                style={{ textAlign: "center", color: "#000", fontSize: "12px" }}
              >
                Created by OwlBooksHouse
              </span>

              <span
                style={{ textAlign: "center", color: "#000", fontSize: "12px" }}
              >
                www.TodaysMiniCrossword.com
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildCrosswordJson;